const Breakpoint = {
  XS: { name: 'xs', minWidth: 400 },
  SM: { name: 'sm', minWidth: 576 },
  MD: { name: 'md', minWidth: 768 },
  LG: { name: 'lg', minWidth: 992 },
  XL: { name: 'xl', minWidth: 1260 },
  XXL: { name: 'xxl', minWidth: 1400 },
};

Object.freeze(Breakpoint);

export default Breakpoint;
